import { Routes } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { AboutComponent } from './component/about/about.component';
import { ContactComponent } from './component/contact/contact.component';
import { ArqitServicesComponent} from './component/arqit-services/arqit-services.component';
import { ErrorNotFoundComponent } from './component/error-not-found/error-not-found.component';
import { TermsAndConditionsComponent } from './component/terms-and-conditions/terms-and-conditions.component';
import { WelcomeEmailComponent } from './component/welcome-email/welcome-email.component';
import { ContactConfirmationComponent } from './component/contact-confirmation/contact-confirmation.component';
import { UnsubscribeComponent } from './component/unsubscribe/unsubscribe.component';
import { JobOfferComponent } from './component/job-offer/job-offer.component';
export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'about', component: AboutComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'arqit-services', component: ArqitServicesComponent },
    { path: 'arqit-services/:id', component: ArqitServicesComponent },
    { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
    { path: 'unsubscribe', component: UnsubscribeComponent },
    { path: 'welcome-email', component: WelcomeEmailComponent },
    { path: 'contact-confirmation', component: ContactConfirmationComponent },
    { path: 'job-offer', component: JobOfferComponent },
    { path: '**', component: ErrorNotFoundComponent }
 ];
    
